import { testimonyRepository } from "../../../providers/repositories/testimonyRepository";
import { Testimony } from "../entities/Testimony";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const getAllTestimoniesUseCase = {
    async exec(trainingId: string): Promise<Testimony[]> {
        try {
            return await testimonyRepository.getAll(trainingId);
        } catch (error) {
            Logger.error("getAllTestimoniesUseCase", error);
            toast.error(t("action.error"));
        }
        return [];
    },
};
